export default "__VITE_ASSET__DxCWkKIm__"